import React from "react";
import { Grid, Mousewheel, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import "swiper/swiper-bundle.min.css";
import PropertyCard from "../../../../../../components/ui/Booking/PropertyCard";
import { Property } from "../../../../../../definitions/property";

interface PropertyGridProps {
  data: Property[];
  slug: string;
  slidesPerViewNum?: number;
}

const PropertyGrid: React.FC<PropertyGridProps> = ({
  data,
  slug,
  slidesPerViewNum,
}) => {
  return (
    <Swiper
      slidesPerView={
        window.innerWidth > 1024
          ? slidesPerViewNum
            ? slidesPerViewNum
            : 5
          : window.innerWidth > 768
          ? 3
          : 1.5
      }
      grid={{
        rows: 1,
      }}
      spaceBetween={16}
      navigation
      mousewheel={{ forceToAxis: true }}
      modules={[Grid, Navigation, Mousewheel]}
      className="mt-8"
    >
      {data.map((data, i) => (
        <SwiperSlide key={i}>
          <PropertyCard data={data} destinationSlug={slug} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default PropertyGrid;
